import React from 'react';
import { IEventResultStore, eventDisciplineWrapper, getServingCompetitorSportId } from 'eTip--common';
import { Blinker, Tooltip } from 'common--design-library';
import { translation } from 'easit--localization';

export interface IMainResult {
    score1: string;
    score2: string
}

export interface ILiveEventcompetitor {
    isServer: boolean;
    name: string;
}

export interface IEventResultsProps {
    eventId: number;
    competitors: ILiveEventcompetitor[];
    graphicsPresentationId: number;
    hasResults: boolean;
    importantResults: IEventResultStore[];
    mainResult: IMainResult;
    otherResults: IEventResultStore[];
    mainResultClass?: string;
    onGoToEventDetail: () => void;
}

export const EventResults = (props: IEventResultsProps) => {

    /*if (!props.competitors || props.competitors.length < 2) {
        throw new Error("EventResults, incorrect competitors");
    }*/

    const competitor1 = props.competitors[0];
    const competitor2 = props.competitors.length > 1 ? props.competitors[1] : null;
    const isBaseball = eventDisciplineWrapper.isBaseball(props.graphicsPresentationId);
    const isAmFootball = eventDisciplineWrapper.isAmFootball(props.graphicsPresentationId);
    const isTennis = eventDisciplineWrapper.isTennis(props.graphicsPresentationId);

    const showSuspendedPlayerResult = (!isAmFootball && !isBaseball && props.otherResults && props.otherResults.length > 0 && props.otherResults[0].isSuspendedPlayer
        && (Number(props.otherResults[0].score1) > 0 || Number(props.otherResults[0].score2) > 0));

    return (
        props.hasResults ?
            (props.importantResults.length > 0 || props.mainResult
                ? <div className="d-flex results-wrapper">
                    <div className="d-flex flex-column">
                        <div className="results-header"></div>
                        <div className="competitor cursor-pointer" onClick={props.onGoToEventDetail}>
                            {competitor1.name}
                            {
                                competitor1.isServer && <span className={`icon-score icon-sport-${getServingCompetitorSportId(props.graphicsPresentationId)}`}></span>
                            }
                            {
                                /* icon is a glove is bad isBaseball && competitor2.isServer && <span className={`icon-score icon-sport-${getServingCompetitorSportId(props.graphicsPresentationId)}a`}></span> */
                            }
                        </div>
                        <div className="competitor cursor-pointer" onClick={props.onGoToEventDetail}>
                            {competitor2.name}
                            {
                                competitor2.isServer && <span className={`icon-score icon-sport-${getServingCompetitorSportId(props.graphicsPresentationId)}`}></span>
                            }
                            {
                                /* icon is a glove is bad isBaseball && competitor1.isServer && <span className={`icon-score icon-sport-${getServingCompetitorSportId(props.graphicsPresentationId)}a`}></span> */
                            }
                        </div>
                    </div>
                    {
                        props.hasResults && props.mainResult &&
                        <div className="d-flex flex-column main-result-col">
                            <div className="results-header">{translation().live_ScoreMainScoreTitle}</div>
                            <div className={`result-value main-result ${props.mainResultClass}`}><Blinker value={Number(props.mainResult.score1)} /></div>
                            <div className={`result-value main-result ${props.mainResultClass}`}><Blinker value={Number(props.mainResult.score2)} /></div>
                        </div>
                    }
                    {
                        showSuspendedPlayerResult &&
                        <div className="d-flex flex-column">
                            <div className="results-header"><span className={`icon-score icon-score-${props.otherResults[0].iconId}`}></span></div>
                            <div className={`result-value main-result ${props.mainResultClass}`}>{props.otherResults[0].score1}</div>
                            <div className={`result-value main-result ${props.mainResultClass}`}>{props.otherResults[0].score2}</div>
                        </div>
                    }
                    {
                        props.importantResults.length > 0 &&
                        props.importantResults.map((result, idx) => <div key={result.iconId} className={`d-flex flex-column text-center ${result.isGame ? "currentPeriodPart" : ""} ${result.isHalf ? "halfTime" : ""}`}>
                            < div className="results-header" >
                                <Tooltip
                                    targetid={`tooltip_res_${idx}_${props.eventId}`} placement="top" autohide={false}
                                    targetFactory={(p) => <span {...p} className={`icon-score icon-score-${result.iconId}`}></span>}
                                >
                                    {result.name}
                                </Tooltip>
                            </div>
                            <div className="result-value">{isTennis && result.score1 === '50' ? 'A' : result.score1}</div>
                            <div className="result-value">{isTennis && result.score2 === '50' ? 'A' : result.score2}</div>
                        </div>)
                    }
                </div>
                : null)
            :
            <div className="px-2 pt-2">{competitor1.name}</div>
    )
}